const StoreNames = ["translations", "checksum", "status", "worldCupMatches", "pointsTable"];

export default StoreNames;
